import { Create } from "react-admin";
import CustomsHouseForm from "./CustomsForm";

const CustomsHouseCreate = () => (
    <Create title={<span>Crear Aduana</span>}>
        <CustomsHouseForm formTitle="crear aduana" />
    </Create>
);

export default CustomsHouseCreate;
